import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["methodInput", "plaidContainer", "manualContainer", "manualLabel", "plaidLabel"]

  connect() {
    // Set initial state based on current selection
    this.toggle()
  }

  toggle() {
    const selectedMethod = this.getSelectedMethod()

    if (selectedMethod === "plaid") {
      this.showPlaid()
    } else if (selectedMethod === "manual") {
      this.showManual()
    }
  }

  getSelectedMethod() {
    const checked = this.methodInputTargets.find(input => input.checked)
    return checked ? checked.value : "plaid" // default to plaid
  }

  showPlaid() {
    // Show/hide containers
    if (this.hasPlaidContainerTarget) {
      this.plaidContainerTarget.classList.remove("hidden")
    }
    if (this.hasManualContainerTarget) {
      this.manualContainerTarget.classList.add("hidden")
    }

    // Update label styling
    if (this.hasPlaidLabelTarget) {
      this.plaidLabelTarget.classList.remove("border-gray-200", "bg-white", "hover:border-gray-300")
      this.plaidLabelTarget.classList.add("border-blue-500", "bg-blue-50")
    }
    if (this.hasManualLabelTarget) {
      this.manualLabelTarget.classList.remove("border-blue-500", "bg-blue-50")
      this.manualLabelTarget.classList.add("border-gray-200", "bg-white", "hover:border-gray-300")
    }
  }

  showManual() {
    // Show/hide containers
    if (this.hasPlaidContainerTarget) {
      this.plaidContainerTarget.classList.add("hidden")
    }
    if (this.hasManualContainerTarget) {
      this.manualContainerTarget.classList.remove("hidden")
    }

    // Update label styling
    if (this.hasManualLabelTarget) {
      this.manualLabelTarget.classList.remove("border-gray-200", "bg-white", "hover:border-gray-300")
      this.manualLabelTarget.classList.add("border-blue-500", "bg-blue-50")
    }
    if (this.hasPlaidLabelTarget) {
      this.plaidLabelTarget.classList.remove("border-blue-500", "bg-blue-50")
      this.plaidLabelTarget.classList.add("border-gray-200", "bg-white", "hover:border-gray-300")
    }
  }
}
